import Typography from '@/components/ui/typography';
import Band from '@/Layouts/Band';
import SectionLayout from '@/Layouts/SectionLayout';
import { Link } from '@inertiajs/react';

const Disclaimer = () => {
  return (
    <Band tone="raised">
      {/* Prose width, matching the privacy policy — a 1024px measure is roughly
          twice what the eye tracks comfortably in continuous text. */}
      <SectionLayout width="prose" space="lg">
        <Typography.H1>Disclaimer</Typography.H1>
        <Typography.Small>Last updated: September 06, 2026</Typography.Small>
        <Typography.H2>Interpretation and Definitions</Typography.H2>
        <Typography.H3>Interpretation</Typography.H3>
        <Typography.Body>
          The words of which the initial letter is capitalized have meanings
          defined under the following conditions. The following definitions
          shall have the same meaning regardless of whether they appear in
          singular or in plural.
        </Typography.Body>
        <Typography.H3>Definitions</Typography.H3>
        <Typography.Body>For the purposes of this Disclaimer:</Typography.Body>
        <ul className="list-disc space-y-3 pl-5 marker:text-thread">
          <li>
            <Typography.Body>
              <strong>Academy</strong> (referred to as either &quot;the
              Academy&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot;
              in this Disclaimer) refers to Samuthrika Academy, 10th Cross West
              Extension, Thillai Nagar, Tiruchirappalli, Tamil Nadu - 620018.
            </Typography.Body>
          </li>
          <li>
            <Typography.Body>
              <strong>Service</strong> refers to the Website.
            </Typography.Body>
          </li>
          <li>
            <Typography.Body>
              <strong>You</strong> means the individual accessing the Service,
              or the academy, or other legal entity on behalf of which such
              individual is accessing or using the Service, as applicable.
            </Typography.Body>
          </li>
          <li>
            <Typography.Body>
              <strong>Website</strong> refers to Samuthrika Academy, accessible
              from{' '}
              <Link
                href={route('home')}
                className="underline underline-offset-4 decoration-1"
              >
                samuthrika.academy
              </Link>
            </Typography.Body>
          </li>
        </ul>
        <Typography.H2>Disclaimer</Typography.H2>
        <Typography.Body>
          The information contained on the Service is for general information
          purposes only.
        </Typography.Body>
        <Typography.Body>
          The Academy assumes no responsibility for errors or omissions in the
          contents of the Service.
        </Typography.Body>
        <Typography.Body>
          In no event shall the Academy be liable for any special, direct,
          indirect, consequential, or incidental damages or any damages
          whatsoever, whether in an action of contract, negligence or other
          tort, arising out of or in connection with the use of the Service or
          the contents of the Service. The Academy reserves the right to make
          additions, deletions, or modifications to the contents on the Service
          at any time without prior notice.
        </Typography.Body>
        <Typography.Body>
          The Academy does not warrant that the Service is free of viruses or
          other harmful components.
        </Typography.Body>
        <Typography.H2>External Links Disclaimer</Typography.H2>
        <Typography.Body>
          The Service may contain links to external websites that are not
          provided or maintained by or in any way affiliated with the Academy.
        </Typography.Body>
        <Typography.Body>
          Please note that the Academy does not guarantee the accuracy,
          relevance, timeliness, or completeness of any information on these
          external websites.
        </Typography.Body>
        <Typography.H2>Third-Party Advertising Disclaimer</Typography.H2>
        <Typography.Body>
          The Service uses third-party advertising and measurement technologies,
          including the Meta Pixel, Meta Conversions API, and Google Ads
          conversion tracking (gtag.js), to measure the performance of Our
          advertising and to show You relevant ads on Meta and Google platforms.
          These third parties operate independently of the Academy and are
          responsible for their own use of the information collected through
          these technologies. See Our{' '}
          <Link
            href={route('privacy-policy')}
            className="underline underline-offset-4 decoration-1"
          >
            Privacy Policy
          </Link>{' '}
          for details on what information is shared and how to opt out.
        </Typography.Body>
        <Typography.H2>Image Credits</Typography.H2>
        <Typography.Body>
          The credit details for the images used on this website are placed at
          the bottom right corner of each image. We have made every effort to
          provide proper credit to the original creators of these images. If you
          believe that any image on this website infringes your copyright,
          please contact us and we will remove the image promptly.
        </Typography.Body>
        <Typography.Body>
          Images were taken from{' '}
          <a
            href="https://pexels.com"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4 decoration-1"
          >
            Pexels
          </a>{' '}
          &{' '}
          <a
            href="https://freepik.com"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4 decoration-1"
          >
            Freepik
          </a>
        </Typography.Body>
        <Typography.H2>Errors and Omissions Disclaimer</Typography.H2>
        <Typography.Body>
          The information given by the Service is for general guidance on
          matters of interest only. Even if the Academy takes every precaution
          to ensure that the content of the Service is both current and
          accurate, errors can occur. Plus, given the changing nature of laws,
          rules and regulations, there may be delays, omissions or inaccuracies
          in the information contained on the Service.
        </Typography.Body>
        <Typography.Body>
          The Academy is not responsible for any errors or omissions, or for the
          results obtained from the use of this information.
        </Typography.Body>
        <Typography.H2>Fair Use Disclaimer</Typography.H2>
        <Typography.Body>
          The Academy may use copyrighted material which has not always been
          specifically authorized by the copyright owner. The Academy is making
          such material available for criticism, comment, news reporting,
          teaching, scholarship, or research.
        </Typography.Body>
        <Typography.Body>
          The Academy believes this constitutes &quot;fair dealing&quot; of any
          such copyrighted material as provided for in Section 52 of the
          (Indian) Copyright Act, 1957.
        </Typography.Body>
        <Typography.Body>
          If You wish to use copyrighted material from the Service for your own
          purposes that go beyond fair dealing, You must obtain permission from
          the copyright owner.
        </Typography.Body>
        <Typography.H2>Views Expressed Disclaimer</Typography.H2>
        <Typography.Body>
          The Service may contain views and opinions which are those of the
          authors and do not necessarily reflect the official policy or position
          of any other author, agency, organization, employer or academy,
          including the Academy.
        </Typography.Body>
        <Typography.Body>
          Comments published by users are their sole responsibility and the
          users will take full responsibility, liability and blame for any libel
          or litigation that results from something written in or as a direct
          result of something written in a comment. The Academy is not liable
          for any comment published by users and reserves the right to delete
          any comment for any reason whatsoever.
        </Typography.Body>
        <Typography.H2>No Responsibility Disclaimer</Typography.H2>
        <Typography.Body>
          The information on the Service is provided with the understanding that
          the Academy is not herein engaged in rendering legal, accounting, tax,
          or other professional advice and services. As such, it should not be
          used as a substitute for consultation with professional accounting,
          tax, legal or other competent advisers.
        </Typography.Body>
        <Typography.Body>
          In no event shall the Academy or its suppliers be liable for any
          special, incidental, indirect, or consequential damages whatsoever
          arising out of or in connection with your access or use or inability
          to access or use the Service.
        </Typography.Body>
        <Typography.H2>
          &quot;Use at Your Own Risk&quot; Disclaimer
        </Typography.H2>
        <Typography.Body>
          All information in the Service is provided &quot;as is&quot;, with no
          guarantee of completeness, accuracy, timeliness or of the results
          obtained from the use of this information, and without warranty of any
          kind, express or implied, including, but not limited to warranties of
          performance, merchantability and fitness for a particular purpose.
        </Typography.Body>
        <Typography.Body>
          The Academy will not be liable to You or anyone else for any decision
          made or action taken in reliance on the information given by the
          Service or for any consequential, special or similar damages, even if
          advised of the possibility of such damages.
        </Typography.Body>
        <Typography.H2>Contact Us</Typography.H2>
        <Typography.Body>
          If you have any questions about this Disclaimer, You can contact Us:
        </Typography.Body>
        <ul className="list-disc space-y-3 pl-5 marker:text-thread">
          <li>
            <Typography.Body>
              By visiting this page on our website:{' '}
              <Link
                href={route('contact')}
                className="underline underline-offset-4 decoration-1"
              >
                samuthrika.academy/contact
              </Link>
            </Typography.Body>
          </li>
        </ul>
      </SectionLayout>
    </Band>
  );
};

export default Disclaimer;
